function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0) { ; } } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import { sortCollection } from '@paperstac/helpers/lib/arrayHelpers';
import reverse from 'lodash/reverse';
import React from 'react';
var SortCollectionContext = /*#__PURE__*/React.createContext();
var Provider = SortCollectionContext.Provider;
var SortCollectionProvider = /*#__PURE__*/React.memo(function (_ref) {
  var children = _ref.children,
    unsortedCollection = _ref.collection,
    initialSortBy = _ref.sortBy,
    initialSortDirection = _ref.sortDirection,
    initialSortLabel = _ref.sortLabel;
  var _React$useState = React.useState({
      sortBy: initialSortBy,
      sortDirection: initialSortDirection,
      sortLabel: initialSortLabel
    }),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    _React$useState2$ = _React$useState2[0],
    sortBy = _React$useState2$.sortBy,
    sortDirection = _React$useState2$.sortDirection,
    sortLabel = _React$useState2$.sortLabel,
    _setSort = _React$useState2[1];
  var collection = handleSortCollection(unsortedCollection, sortBy, sortDirection);
  var providerValue = React.useMemo(function () {
    return {
      collection: collection,
      sortCollection: function sortCollection(unsortedCollection) {
        if (!unsortedCollection || !unsortedCollection.length) return unsortedCollection;
        return handleSortCollection(unsortedCollection, sortBy, sortDirection);
      },
      lastUpdated: new Date().toISOString(),
      setSort: function setSort(sortBy, sortDirection, sortLabel) {
        return _setSort({
          sortBy: sortBy,
          sortDirection: sortDirection,
          sortLabel: sortLabel
        });
      },
      sortBy: sortBy,
      sortDirection: sortDirection,
      sortLabel: sortLabel
    };
  }, [collection, _setSort, sortBy, sortDirection, sortLabel]);
  return /*#__PURE__*/React.createElement(Provider, {
    value: providerValue,
    children: children
  });
});
SortCollectionProvider.propTypes = {};
SortCollectionProvider.defaultProps = {
  sortBy: '',
  sortDirection: 'ASC',
  sortLabel: 'Default'
};
SortCollectionProvider.displayName = 'SortCollectionProvider';
export default SortCollectionProvider;
export { SortCollectionContext };
var handleSortCollection = function handleSortCollection(results, sortBy, sortDirection) {
  if (!results) return results;
  if (sortBy === '' && sortDirection.toUpperCase() === 'ASC') return results;
  if (sortBy === '' && sortDirection.toUpperCase() === 'DESC') return reverse(results);
  return sortCollection(results, sortBy, sortDirection);
};